<template>
  <path
    d="M20 4.00024H4C2.9 4.00024 2 4.90024 2 6.00024V18.0002C2 19.1002 2.9 20.0002 4 20.0002H13V18.0002H4V8.00024L10.94 12.3402C11.59 12.7502 12.41 12.7502 13.06 12.3402L20 8.00024V13.0002H22V6.00024C22 4.90024 21.1 4.00024 20 4.00024ZM12 11.0002L4 6.00024H20L12 11.0002ZM19 16.2102C19 15.7602 19.54 15.5402 19.85 15.8602L22.64 18.6502C22.84 18.8502 22.84 19.1602 22.64 19.3602L19.85 22.1502C19.54 22.4602 19 22.2402 19 21.7902V20.0002H16C15.45 20.0002 15 19.5502 15 19.0002C15 18.4502 15.45 18.0002 16 18.0002H19V16.2102Z"
  />
</template>
